<script lang="ts">
  export let color = 'currentColor';
  export let size: string | number = 20;
  export let hoveredColor = color;

  let placeholderColor;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svg
  on:mouseenter={() => {
    placeholderColor = color;
    color = hoveredColor;
  }}
  on:mouseleave={() => {
    color = placeholderColor;
  }}
  width={size}
  height={size}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.46448 6.46436L13.5355 13.5354"
    stroke={color}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M6.46445 13.5354L13.5355 6.46436"
    stroke={color}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
